module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgwhite black",
    style: ({
      transformStyle: (_vm.isDialogActive ? 'flat' : 'preserve-3d')
    }),
    attrs: {
      "id": "promises",
      "data-type": "layout",
      "data-header": "green"
    }
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('h3', {
    staticClass: "mt3",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-green mt3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openDialog($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.page.callToAction))])]), _vm._v(" "), (_vm.isDialogActive) ? _c('div', {
    staticClass: "span-dialogs-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "simple-fade"
    }
  }, [(_vm.isDialogListActive) ? _c('div', {
    staticClass: "span-dialogs span-full"
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "item-dialog item-dialog-single pt3 pb3 content-500",
    class: 'bg' + _vm.activeDialog.background_color
  }, [_c('h3', {
    staticClass: "uppercase pl3 pr3 pb1"
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.activeDialog.content))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-white white mt1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNext($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeDialog.trigger))])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "simple-fade-confirmation"
    }
  }, [(_vm.isConfirmationActive) ? _c('div', {
    key: 'confirmation',
    staticClass: "span-confirmation span-full"
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "item-dialog item-dialog-confirmation pt3 pb3 content-750 bgblue"
  }, [_c('h2', [_vm._v(_vm._s(_vm.confirmation.title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pl3 pr3 pt2 pl5 pr5"
  }, [_c('p', {
    staticClass: "title-font"
  }, [_vm._v(_vm._s(_vm.confirmation.content))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-white mt2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeConfirmation($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmation.close))])])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57adf2b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Solutions-promises.vue
// module id = 161
// module chunks = 1